var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDirectoryUploadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.79 7.403c-.273-.515-.756-.822-1.293-.822H4.56c-.592 0-1.13.389-1.372.991L.031 15.296c.119.566.572.988 1.111.988h12.7c.544 0 1.04-.358 1.283-.925l2.729-6.382a1.845 1.845 0 0 0-.063-1.574Z",
  fill: "#C1C4D8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.545 6.384c.242-.602.78-.991 1.372-.991h11.241V3.715c0-.691-.5-1.254-1.114-1.254H7.489a.031.031 0 0 1-.019-.005L6.297.542C6.09.202 5.747 0 5.38 0H1.115C.5 0 0 .563 0 1.254V12.61l2.545-6.226Z",
  fill: "#C1C4D8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m5 14 3-3m0 0 3 3m-3-3v5.5",
  stroke: "#fff"
})));
export { SvgDirectoryUploadIcon as ReactComponent };
export default __webpack_public_path__ + "e2d4f167196f65bae96f1336ba578dfd.svg";